import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Heading from '../../components/heading/Heading';
import StepsSummaryBox from '../../components/stepsSummaryBox/StepsSummaryBox';
import CustomerInformation from '../../components/customer-information/CustomerInformation';
import StepBar from '../../components/steps-bar/StepsBar';

const StepOne = ( props ) => {
    let [ load, setLoad ] = useState(false);
    let productPrice     = useSelector(state => state.productPrice);
    let isShop     = useSelector(state => state.isShop);
    let minThreshold     = useSelector(state => state.minThreshold);
    let maxThreshold     = useSelector(state => state.maxThreshold);



    const dispatch = useDispatch()

    useEffect(() => {
        if ( !load ) {
            if ( productPrice < minThreshold ) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                 
              } 
              else if( productPrice >= minThreshold && productPrice < maxThreshold ) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                  
              } 
              else if( productPrice >= maxThreshold) {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
                
              } 
              else {
                dispatch({ type: 'STEPS_CHANGE', value: 2 })
              }
              if(typeof window !== "undefined") {
                window.dataLayer.push({'event':'pageview'});
              }
            setLoad(true);
        } 
    }, [load])

    let prev = () => {
        props.history.push(isShop ? '/sklep':'/')
    }
    let next = () => {
        props.history.push('/krok/3')
    }
    
    return (
        <>
        <StepBar />
        <section className="form steps">
            <div className="container-step">
                <div className="row" >
                    {/* <StepsSummaryBox /> */}
                    <CustomerInformation prev={ () => prev() } next={ () => next() } />
                </div>
            </div>
        </section>
        </>
    )
}

export default StepOne;